export function isKeepsafeMother(keepsafe:AnnouncementKeepsafe | AnnouncementKeepsafeForeignCurrency) {
    let isMother = false;

    if(!keepsafe.detail[0] || keepsafe.detail.length > 1){ return true; }
    if(keepsafe.detail[0].bag === '') { return false; }

    isMother = !(keepsafe.detail[0].bag === keepsafe.keepsafe)

    return isMother
}